import React from 'react';
import styled from 'styled-components';
import { FeatureListContentfulModel } from 'src/api/models/FeatureList';
import Features from 'src/organisms/featureList/features';

const FeatureListContainer = styled.div`
  max-width: 1440px;
  width: 100%;
  margin: 0 auto;
  position: relative;
  padding: 2em 0 4em;
`

export default function getDynamicFeatures(featureProps: FeatureListContentfulModel): React.ReactNode {
  return (
    <FeatureListContainer>
      <Features features={featureProps.contentfulchildren} removeConfetti />
    </FeatureListContainer>
  );
}
